import { Component, Input, OnInit } from '@angular/core';
import { BnEsDatePipe } from '../pipes/bn-es-date-pipe/bn-es-date.pipe';

interface SemaphoreObject {
  type?: string;
  text?: string;
}

@Component({
  selector: 'bn-account-detail-credit-card',
  templateUrl: './account-detail-credit-card.component.html',
})
export class BnAccountDetailCreditCardComponent implements OnInit {
  @Input() product: any;
  @Input() productNumberFormat: any;
  @Input() hostRef: any;
  localCurrency = 'DOP';
  foreignCurrency = 'USD';
  infoTooltipText = $localize`:@@product-details.infoLabel:Total payments made for the pending statement`;
  overdueTooltipText = $localize`:@@product-details.overdueLabel:Statement payment overdue`;
  successTooltipText = $localize`:@@product-details.successLabel:Statement paid`;
  greyTooltipText = $localize`:@@product-details.greyLabel:Statement payment pending`;
  dopSemaphore: SemaphoreObject = {};
  usdSemaphore: SemaphoreObject = {};

  title1 = $localize`:@@product-details.h2.accountDetails:Account Detail`;
  title2 = $localize`:@@product-details.h2.balances:Balances`;
  title3 = $localize`:@@product-details.h2.statements:Statements`;
  title4 = $localize`:@@product-details.h2.otherInfo:Other information`;

  ngOnInit(): void {
    this.dopSemaphore = this.setTooltips(this.product?.additions?.minimumPmtSemaphoreDOP?.toLowerCase());
    this.usdSemaphore = this.setTooltips(this.product?.additions?.minimumPmtSemaphoreUSD?.toLowerCase());
  }

  setTooltips(semaphoreValue: string): SemaphoreObject {
    switch (semaphoreValue) {
      case 'green':
        return {
          type: 'success',
          text: this.successTooltipText,
        };
      case 'red':
        return {
          type: 'danger',
          text: this.overdueTooltipText,
        };
      case 'gray':
        return {
          type: 'grey',
          text: this.greyTooltipText,
        };
      default:
        return {};
    }
  }

  parseGreenPoints(greenPoints: string): string {
    return greenPoints !== '-1' ? greenPoints.replace(/,/g, '') : '-1';
  }
}
